import { useState } from "react";

import { Divider } from "@mui/material";

import HeaderInfo from "../utils/HeaderInfo";
import useAuth from "../../hooks/useAuth";
import { DISPLAYING_FOR } from "../../config/AppEnums";

import "./css/comment.css";

const Comment = (props) => {
    const { auth } = useAuth();
    const {
        serialNumber,
        commentFor,
        commentForId,
        commentId,
        commentById,
        commentBy,
        commentedOn,
        updatedOn,
        commentBody,
        updateableComments,
        setUpdateableComments
    } = props;
    const [updateableCommentBody, setUpdateableCommentBody] = useState(commentBody);
    const [updateableUpdatedOn, setUpdateableUpdatedOn] = useState(updatedOn);

    return (
        <>
            {serialNumber > 0 &&
                <>
                    <Divider
                        style={{
                            marginTop: "16px" // var(--gap)
                        }}
                    />
                    <br />
                </>
            }

            <HeaderInfo
                displayingFor={DISPLAYING_FOR.COMMENT}
                userId={commentById}
                name={commentBy}
                askedOn={commentedOn}
                updatedOn={updateableUpdatedOn}
                data={{
                    contentOf: "comment",
                    commentFor: commentFor,
                    commentForId: commentForId,
                    commentId: commentId,
                    content: {
                        body: commentBody
                    },
                    updateableData: {
                        setUpdateableCommentBody,
                        setUpdateableUpdatedOn,
                        updateableComments,
                        setUpdateableComments
                    }
                }}
                isUserAuthenticated={commentById === auth.userId}
            />

            <div id={commentId} className="comment">
                {updateableCommentBody.split("\n").map((text, key) => {
                    return (
                        <span key={key}>
                            {text}
                            <br />
                        </span>
                    );
                })}
            </div>
        </>
    );
}

export default Comment;